<template>
	<b-modal
		id="invoice-modal"
		v-model="isVisible"
		hide-footer
		title="Счёт"
		size="xl"
		@hidden="$emit('close')"
	>
		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<h5>Счёт</h5>
			<b-button v-if="!isPdfReady" variant="primary" disabled>
				<b-spinner small />
				Создаем PDF версию документа...
			</b-button>
			<a v-if="isPdfReady" :href="downloadUrl" download>
				<b-button variant="primary">
					Скачать PDF
				</b-button>
			</a>
			<b-button size="sm" variant="outline-danger" @click="close()">
				Закрыть
			</b-button>
		</template>
		<b-container v-if="$fetchState.pending" class="d-flex justify-content-center mb-3">
			<b-spinner
				style="width: 3em; height: 3em; margin-right: 10px;"
			/>
		</b-container>
		<b-container v-else-if="$fetchState.error">
			{{ $fetchState.error }}
		</b-container>
		<div v-else-if="invoice.data" class="d-flex justify-content-center">
			<div class="col-12 col-lg-10">
				<div v-if="invoice.data.template" v-html="invoice.data.template">
					счёт
				</div>
			</div>
		</div>
		<b-container v-else-if="invoice.error">
			{{ invoice.error }}
		</b-container>
	</b-modal>
</template>

<script>
import { ACTION_HANDLE_UNIQUE_ID, UNIQUE_ID_STORE_NAMESPACE } from '~/store/uniqueId';

export default {
	name: 'InvoicePopup',
	props: {
		value: { type: Boolean, required: true },
		formId: { type: Number, required: true },
		orderId: { type: Number, required: true },
	},
	async fetch() {
		if (!this.isVisible) return;

		const {
			$api, $store, $cookies, formId,
		} = this;
		await $store.dispatch(`${UNIQUE_ID_STORE_NAMESPACE}/${ACTION_HANDLE_UNIQUE_ID}`, { $cookies });
		const { uniqueId } = $store.state.uniqueId;
		try {
			this.invoice.data = await $api.getInvoiceData({ uniqueId, formId });
			this.isPdfReady = this.invoice.data.isPdfReady;
			if (!this.isPdfReady) {
				this.jobId = this.invoice.data.jobId;
				this.pdfTimeoutId = setTimeout(this.checkPdfStatus, 1000);
			} else {
				this.pdfUrl = this.invoice.data.pdfUrl;
			}
		} catch (error) {
			try {
				const {
					message,
					errors,
				} = this.$api.getValidationFromError(error);
				this.invoice.error = message;
				this.invoice.errors = errors;
			} catch {
				this.$logger.log(error);
				this.invoice.error = 'Что-то пошло не так, но мы уже знаем об этом';
				this.invoice.errors = {};
			}
		}
	},
	data() {
		return {
			invoice: {
				data: null,
				error: null,
				errors: {},
			},
			isPdfReady: false,
			jobId: '',
			pdfUrl: false,
			pdfTimeoutId: null,
			baseApiUrl: process.env.BASE_API_URL,
		};
	},
	computed: {
		isVisible: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		downloadUrl() {
			return `${this.baseApiUrl
			}/api/checkout/invoice/pdf?uniqueId=${this.$store.state.uniqueId.uniqueId
			}&formId=${this.formId
			}&download=true`;
		},
	},
	watch: {
		isVisible(is) {
			if (is) {
				this.$fetch();
			} else {
				this.clearPdfTimeout();
			}
		},
	},
	beforeDestroy() {
		this.clearPdfTimeout();
	},
	methods: {
		async checkPdfStatus() {
			try {
				const response = await this.$api.getInvoicePdf({
					uniqueId: this.$store.state.uniqueId.uniqueId,
					formId: this.formId,
					jobId: this.jobId,
				});
				if (response.isPdfReady) {
					this.isPdfReady = true;
					this.pdfUrl = response.pdfUrl;
				} else {
					this.pdfTimeoutId = setTimeout(this.checkPdfStatus, 1000);
				}
			} catch {
				this.pdfTimeoutId = setTimeout(this.checkPdfStatus, 1000);
			}
		},
		clearPdfTimeout() {
			if (this.pdfTimeoutId) {
				clearTimeout(this.pdfTimeoutId);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~/assets/styles/components/dev/print";
</style>
